export enum Taxes {
    IVA16 = 1,
    IVA8 = 2,
    Other
}

export const taxesValues: { [id: number]: string } = {
    1: '16%',
    2: '8%',
    3: 'Otro'
  };
  
  export namespace Taxes {
    export function items() {
      var items = Object.keys(Taxes)
        .filter((type) => isNaN(<any>type) && type !== 'values')
        .map((key, index) => {
          return { key: taxesValues[+index + 1], value: +index + 1 };
        });
      return items.filter((x) => x.key != undefined);
    }
  }